import { render } from "./SessionOverview.vue?vue&type=template&id=54205cd4&scoped=true"
import script from "./SessionOverview.vue?vue&type=script&lang=js"
export * from "./SessionOverview.vue?vue&type=script&lang=js"

import "./SessionOverview.vue?vue&type=style&index=0&id=54205cd4&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54205cd4"]])

export default __exports__